import Vue from 'vue'
import Router from 'vue-router'
import qudi from '../components/qudi.vue';
import samajuri from '../components/samajuri.vue';
import chanta from '../components/chanta.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: 'www.gulisa.tsiklauri.ge',
      name: 'qudi',
      component: qudi
    },
    {
      path: '/',
      name: 'qudi',
      component: qudi
    },
    {
      path: '/qudi',
      name: 'qudi',
      component: qudi
    },
    {
      path: '/samajuri',
      name: 'samajuri',
      component: samajuri
    },
    {
      path: '/chanta',
      name: 'chanta',
      component: chanta
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js